import type { RequestProductsMetadata } from 'src/redux/products/types';
import { DELIVERY_DAYS_FACET_KEY } from 'src/utils/deliveryChipDates';
import { GUARANTEED_ARRIVAL_DAYS } from 'src/utils/guaranteedArrivalDays';
import type {
  ProductsQueryState,
  SyncProductsQueryFromURLPayload,
} from '../types/ProductsQueryState';

/**
 * Describes the guaranteed arrival toggle being turned on or off, tracked as an option of
 * the delivery facet. Only while the chosen date stays the same: choosing another date
 * clears the day as a side effect, and that is a date change rather than a toggle.
 */
export const getGuaranteedArrivalChangeMetadata = (
  current: ProductsQueryState,
  next: SyncProductsQueryFromURLPayload,
): RequestProductsMetadata | undefined => {
  const day = next.guaranteedArrivalDay ?? current.guaranteedArrivalDay;
  const deliveryFacet = current.facets.find((facet) => facet.key === DELIVERY_DAYS_FACET_KEY);

  if (!day || current.guaranteedArrivalDay === next.guaranteedArrivalDay || !deliveryFacet) {
    return undefined;
  }

  const currentDate = deliveryFacet.options.find((option) => option.active)?.value;
  const nextDate = next.activeFacetValuesByKey[deliveryFacet.alias]?.[0];

  if (currentDate !== nextDate) {
    return undefined;
  }

  return {
    facetTitle: deliveryFacet.title,
    optionActive: next.guaranteedArrivalDay !== undefined,
    // Not the toggle's label, so rewording the toggle does not change the tracked value.
    optionTitle: `Guaranteed ${GUARANTEED_ARRIVAL_DAYS[day].name}`,
  };
};
